import React from 'react';
import { LinkIcon } from 'lucide-react';
import { LegalBlockView } from './LegalBlockView';
import { scrollToAnchor } from '../../utils/scroll';
import type { LegalSection } from '../../types/legal';
type LegalSectionViewProps = {
  section: LegalSection;
  number: number;
};
export function LegalSectionView({
  section,
  number
}: LegalSectionViewProps) {
  return <section id={section.id} aria-labelledby={`${section.id}-title`} className="scroll-mt-[112px]" data-id="element-728" data-mp="16cp8zds5c3lg">
      <AnchorHeading id={section.id} level={2} data-id="element-729" data-mp="1u2t22r7pkky7">
        <span className="mr-2.5 tabular-nums text-ink-muted" data-id="element-730" data-mp="1y0z5bp9c8ied">{number}.</span>
        {section.title}
      </AnchorHeading>
      <div className="mt-5 space-y-5" data-id="element-731" data-mp="1ka41irdp4rhn">
        {section.blocks.map((block, i) => <LegalBlockView key={i} block={block} data-id="element-732" data-mp="1p8fbr37wl40e" data-mpi={i} />)}
      </div>

      {section.subsections?.map((sub, j) => {
      const subId = `${section.id}-${j + 1}`;
      return <div key={subId} id={subId} className="mt-8 scroll-mt-[112px]" data-id="element-733" data-mp="2hr2tc8noy0wq">
            <AnchorHeading id={subId} level={3} data-id="element-734" data-mp="2ggynw2temq4r">
              <span className="mr-2 tabular-nums text-ink-muted" data-id="element-735" data-mp="2ghrr4tt5mxi5">
                {number}.{j + 1}
              </span>
              {sub.title}
            </AnchorHeading>
            <div className="mt-3.5 space-y-4" data-id="element-736" data-mp="2q833n4qwmf0n">
              {sub.blocks.map((block, i) => <LegalBlockView key={i} block={block} data-id="element-737" data-mp="2lg30l3fjf5zu" data-mpi={i} />)}
            </div>
          </div>;
    })}
    </section>;
}
function AnchorHeading({
  id,
  level,
  children
}: {
  id: string;
  level: 2 | 3;
  children: React.ReactNode;
}) {
  const Tag = level === 2 ? 'h2' : 'h3';
  const size = level === 2 ? 'text-[22px] sm:text-[24px]' : 'text-[17px]';
  return <Tag id={`${id}-title`} className={`group relative font-semibold tracking-[-0.02em] text-ink ${size}`} data-id="element-738" data-mp="3472hdhcvp9i1">
      {children}
      <a href={`#${id}`} onClick={e => {
      e.preventDefault();
      scrollToAnchor(id);
    }} aria-label="Link to this section" className="ml-2 inline-flex translate-y-[-1px] align-middle text-ink-muted opacity-0 transition-opacity duration-150 ease-out hover:text-brand focus-visible:opacity-100 group-hover:opacity-100 print:hidden" data-id="element-739" data-mp="1er34pqa1x1xn">
        <LinkIcon className="h-4 w-4" aria-hidden="true" data-id="element-740" data-mp="3jsz04amyxr0h" />
      </a>
    </Tag>;
}